var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31836 10.7832C4.66992 10.7832 4.9248 10.5195 4.9248 10.1592V8.7002L4.78418 5.72949L7.43848 8.46289L10.2861 11.3369C10.4004 11.4512 10.5498 11.5127 10.708 11.5127C11.0859 11.5127 11.3584 11.2666 11.3584 10.8887C11.3584 10.7129 11.2969 10.5547 11.1826 10.4316L8.30859 7.56641L5.5752 4.9209L8.55469 5.07031H10.0137C10.3652 5.07031 10.6465 4.82422 10.6465 4.46387C10.6465 4.10352 10.374 3.84863 10.0137 3.84863H4.77539C4.10742 3.84863 3.70312 4.25293 3.70312 4.92969V10.1592C3.70312 10.5107 3.95801 10.7832 4.31836 10.7832ZM13.9863 20.46H19.2246C19.9014 20.46 20.2969 20.0557 20.2969 19.3789V14.1494C20.2969 13.7979 20.0508 13.5254 19.6904 13.5254C19.3301 13.5254 19.0752 13.7891 19.0752 14.1494V15.6172L19.2246 18.5791L16.5615 15.8457L13.7139 12.9805C13.5996 12.8574 13.4502 12.8047 13.292 12.8047C12.9141 12.8047 12.6416 13.0508 12.6416 13.4287C12.6416 13.5957 12.7031 13.7539 12.8262 13.877L15.6914 16.7422L18.4248 19.3877L15.4453 19.2383H13.9863C13.6348 19.2383 13.3623 19.4844 13.3535 19.8447C13.3535 20.2051 13.626 20.46 13.9863 20.46Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/Fullscreen.027837770f275c9b57045ebf48e6573d.svg";
export { ForwardRef as ReactComponent };